import React from 'react';
import { Phone, CheckCircle, DollarSign, Info, Shield } from 'lucide-react';
export function DotForLifePage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-4861">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-4862">
        <div className="container mx-auto px-4" data-id="element-4863">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-4864">
            DOT For Life Program
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-4865">
            Complete DOT Compliance & Inspection Service
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-4866">
        <div className="max-w-4xl mx-auto" data-id="element-4867">
          {/* Commercial Motor Vehicle Definition */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4868">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4869">
              <Info className="mr-3 text-blue-600" size={28} data-id="element-4870" />
              What is a Commercial Motor Vehicle?
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-4871">
              You are operating a commercial motor vehicle if you transport
              passengers or property in a vehicle that:
            </p>

            <div className="space-y-6" data-id="element-4872">
              {/* Actual Weight */}
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6" data-id="element-4873">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-4874">
                  Has an actual gross vehicle weight (GVW) or gross combination
                  vehicle weight (GCW) of 10,001 pounds or more
                </h3>
                <div className="space-y-2 ml-4" data-id="element-4875">
                  <div className="flex items-start" data-id="element-4876">
                    <span className="mr-2" data-id="element-4877">•</span>
                    <p className="text-gray-700" data-id="element-4878">
                      <strong data-id="element-4879">GVW</strong> means the weight of a vehicle and its
                      load
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-4880">
                    <span className="mr-2" data-id="element-4881">•</span>
                    <p className="text-gray-700" data-id="element-4882">
                      <strong data-id="element-4883">GCW</strong> means the weight of a combination
                      vehicle and its load
                    </p>
                  </div>
                </div>
              </div>

              {/* Rated Weight */}
              <div className="bg-green-50 border-l-4 border-green-500 p-6" data-id="element-4884">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-4885">
                  Has a gross vehicle weight rating (GVWR) or gross combination
                  weight rating (GCWR) of 10,001 pounds or more
                </h3>
                <div className="space-y-2 ml-4" data-id="element-4886">
                  <div className="flex items-start" data-id="element-4887">
                    <span className="mr-2" data-id="element-4888">•</span>
                    <p className="text-gray-700" data-id="element-4889">
                      <strong data-id="element-4890">GVWR</strong> is the value specified by the
                      manufacturer as a safe loaded weight of a single vehicle
                      (the GVWR is located on the manufacturer's tag, usually
                      found inside the driver's side door)
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-4891">
                    <span className="mr-2" data-id="element-4892">•</span>
                    <p className="text-gray-700" data-id="element-4893">
                      <strong data-id="element-4894">GCWR</strong> is the value specified by the
                      manufacturer as the loaded weight of a combination of
                      vehicles
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Here's How it Works */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-4895">
            <h2 className="text-3xl font-bold mb-6 text-center" data-id="element-4896">
              Here's How it Works
            </h2>

            <div className="bg-white text-gray-900 rounded-lg p-6 mb-6 text-center" data-id="element-4897">
              <p className="text-2xl font-bold mb-2 flex items-center justify-center" data-id="element-4898">
                <DollarSign className="text-green-600" size={32} data-id="element-4899" />
                Sign up fee for each Truck is $225.00
              </p>
            </div>

            <div className="space-y-4" data-id="element-4900">
              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-4901">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-4902">
                  1.
                </span>
                <div data-id="element-4903">
                  <p className="text-lg font-semibold" data-id="element-4904">
                    We will do your DOT inspection Yearly for Free
                  </p>
                  <p className="text-gray-200" data-id="element-4905">$99.00 Value</p>
                </div>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-4906">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-4907">
                  2.
                </span>
                <p className="text-lg" data-id="element-4908">
                  Pick up your Truck when its due for inspection
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-4909">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-4910">
                  3.
                </span>
                <p className="text-lg" data-id="element-4911">
                  Free fluid top off Between oil changes (Fuel excluded)
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-4912">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-4913">
                  4.
                </span>
                <p className="text-lg font-semibold" data-id="element-4914">
                  DOT COMPLIANCE MANAGEMENT
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-4915">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-4916">
                  5.
                </span>
                <p className="text-lg" data-id="element-4917">
                  Help explaining tickets and ticket avoidance
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-4918">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-4919">
                  6.
                </span>
                <p className="text-lg" data-id="element-4920">
                  Keep you up to date on DOT Law changes
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-4921">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-4922">
                  7.
                </span>
                <p className="text-lg" data-id="element-4923">Monthly Light inspection</p>
              </div>
            </div>

            <div className="bg-yellow-50 text-gray-900 rounded-lg p-6 mt-6 text-center" data-id="element-4924">
              <p className="text-lg font-semibold" data-id="element-4925">
                By Following our recommendations you will greatly reduce your
                yearly ticket cost.
              </p>
            </div>
          </div>

          {/* Pricing */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8 text-center" data-id="element-4926">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center justify-center" data-id="element-4927">
              <Shield className="mr-3 text-[#B1050B]" size={32} data-id="element-4928" />
              Program Pricing
            </h2>
            <div className="bg-green-50 border-2 border-green-500 rounded-lg p-8 inline-block" data-id="element-4929">
              <p className="text-lg text-gray-700 mb-2" data-id="element-4930">Regular Price</p>
              <p className="text-5xl font-bold text-[#B1050B]" data-id="element-4931">$225.00</p>
              <p className="text-gray-600 mt-2" data-id="element-4932">per truck, per year</p>
            </div>
          </div>

          {/* Program Benefits Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4933">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-4934">
              What's Included
            </h2>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-4935">
              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-4936">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4937" />
                <div data-id="element-4938">
                  <p className="font-semibold text-gray-900" data-id="element-4939">
                    Free Yearly DOT Inspection
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-4940">$99 value included</p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-4941">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4942" />
                <div data-id="element-4943">
                  <p className="font-semibold text-gray-900" data-id="element-4944">
                    Inspection Pickup Service
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-4945">We come to you</p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-4946">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4947" />
                <div data-id="element-4948">
                  <p className="font-semibold text-gray-900" data-id="element-4949">
                    Free Fluid Top-Offs
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-4950">
                    Between oil changes (fuel excluded)
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-4951">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4952" />
                <div data-id="element-4953">
                  <p className="font-semibold text-gray-900" data-id="element-4954">
                    DOT Compliance Management
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-4955">
                    Stay compliant year-round
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-4956">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4957" />
                <div data-id="element-4958">
                  <p className="font-semibold text-gray-900" data-id="element-4959">
                    Ticket Help & Avoidance
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-4960">
                    Expert guidance and support
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-4961">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4962" />
                <div data-id="element-4963">
                  <p className="font-semibold text-gray-900" data-id="element-4964">DOT Law Updates</p>
                  <p className="text-sm text-gray-600" data-id="element-4965">
                    Stay informed on changes
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-4966">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4967" />
                <div data-id="element-4968">
                  <p className="font-semibold text-gray-900" data-id="element-4969">
                    Monthly Light Inspection
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-4970">Regular safety checks</p>
                </div>
              </div>
            </div>
          </div>

          {/* Simple Rules */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4971">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-4972">
              Simple Rules
            </h2>

            <div className="space-y-4" data-id="element-4973">
              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-4974">
                <p className="text-gray-800" data-id="element-4975">
                  <strong data-id="element-4976">One membership per truck</strong> - You will need to
                  buy one membership per truck
                </p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-4977">
                <p className="text-gray-800" data-id="element-4978">
                  <strong data-id="element-4979">Repairs extra</strong> - Repair costs are not included
                  in membership
                </p>
              </div>

              <div className="bg-green-50 border-l-4 border-green-500 p-4" data-id="element-4980">
                <p className="text-gray-800" data-id="element-4981">
                  <strong data-id="element-4982">Transferable</strong> - Membership is transferable
                  from old truck to replacement truck
                </p>
              </div>
            </div>
          </div>

          {/* Value Proposition */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-xl p-8 mb-8 text-center" data-id="element-4983">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4984">
              Save Money & Stay Compliant
            </h2>
            <p className="text-xl mb-2" data-id="element-4985">
              By following our recommendations, you will greatly reduce your
              yearly ticket cost.
            </p>
            <p className="text-lg text-green-100" data-id="element-4986">
              One membership covers everything you need for DOT compliance
            </p>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-4987">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4988">
              Join the DOT For Life Program Today
            </h2>
            <p className="text-xl mb-6" data-id="element-4989">
              Complete DOT compliance and inspection service for just $225/year
              per truck
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-4990">
              <Phone className="mr-3" size={24} data-id="element-4991" />
              Call (248) 478-8382 to Sign Up
            </a>
            <p className="mt-4 text-gray-300" data-id="element-4992">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}